import { Settings } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Настройки клиники (Приложение D; матрица 2.2 «Реквизиты клиники, филиалы»: OWNER — изменение;
 * MED_DIR, OPS_DIR, FRONT_DESK, ACCOUNTANT — чтение; выгрузка — OWNER, решение о записях — главврач).
 */
export const section = defineSection({
  id: 'org.settings',
  area: 'clinic',
  path: 'settings/clinic',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'FRONT_DESK', 'ACCOUNTANT'],
  icon: Settings,
  titleKey: 'clinicSettings:title',
  namespaces: ['portal'],
  navGroup: 'manage',
  order: 23,
  navRoles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'ACCOUNTANT'],
  tabGroup: 'clinic',
  load: () => import('./ClinicSettingsPage'),
});

/** Ссылки из уведомлений (ПОРТ-50, ПОРТ-51): выгрузка и акт удаления — вкладка «Данные» настроек клиники. */
export const sections = [
  defineSection({
    id: 'org.settings.export-link',
    area: 'clinic',
    path: 'settings/export',
    roles: ['OWNER', 'MED_DIRECTOR'],
    icon: Settings,
    titleKey: 'clinicSettings:title',
    namespaces: ['portal'],
    order: 801,
    nav: false,
    load: () => import('./DataTabRedirect'),
  }),
  defineSection({
    id: 'org.settings.deletion-link',
    area: 'clinic',
    path: 'deletion-requests/*',
    roles: ['OWNER'],
    icon: Settings,
    titleKey: 'clinicSettings:title',
    namespaces: ['portal'],
    order: 802,
    nav: false,
    load: () => import('./DataTabRedirect'),
  }),
];
